import NotificationApi from '@apis/notification/NotificationApi';
import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { NotificationRow } from '@models/notification';
import { useFlow } from '@stackflow/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

function useNotificationClick(notification: NotificationRow) {
    const { t } = useTranslation('notification');
    const {
        notificationId, entityType, entityId, type,
    } = notification;
    const queryClient = useQueryClient();
    const toast = useToast();
    const { push } = useFlow();
    const handleMove = () => {
        if (type === 'ORDER' && entityId) {
            push('OrderLogsActivity', { duration: 'WEEK' }, { animate: false });
            push('OrderLogActivity', { orderNo: entityId });
        }
        if (type === 'COUPON') {
            if (entityId) {
                push('CouponActivity', { type: 'MY' }, { animate: false });
                push('CouponDetailActivity', { couponId: entityId });
            } else {
                push('CouponActivity', { type: 'MY' });
            }
        }
        if (type === 'STAMP') {
            push('StampsActivity', {});
        }
        if (type === 'GIFT') {
            push('GiftsActivity', { type: 'MAIN' });
        }
        if (type === 'INQUIRY') {
            if (entityId) {
                push('InquiryActivity', { type: 'READ' }, { animate: false });
                push('InquiryLogActivity', { inquiryId: entityId });
            } else {
                push('InquiryActivity', { type: 'READ' });
            }
        }
        if (type === 'EVENT' && entityId) {
            push('BoardActivity', { type: 'EVENT' }, { animate: false });
            push('EventActivity', { eventId: entityId });
        }
    };
    const { mutate } = useMutation({
        mutationFn: () => NotificationApi.read(notificationId),
        onSuccess() {
            queryClient.invalidateQueries({
                queryKey: queries.notifications._def,
            });
        },
        onError(e: AxiosError<ErrorResponse>) {
            toast.error(e.response?.data.message || t('toast.readError'));
        },
    });
    return () => {
        mutate();
        handleMove();
    };
}

export default useNotificationClick;
